export default "__VITE_ASSET__uAayHhE0__"